<template>
  <vx-card>
    <div class="w-full" style="display: flex !important; flex-direction: column">
      <div class="flex mb-4">
        <vs-select v-if="perPage" v-model="perPage" autocomplete class="mr-4" style="width: 110px" @input="onChangePerPage">
          <vs-select-item v-for="v in [10, 20, 30, 50]" :text="`${v}개씩 보기`" :value="v" />
        </vs-select>
      </div>
      <div class="w-full overflow-x-auto">
        <table class="theme-table" :style="minWidth ? `min-width: ${minWidth}px` : ''">
          <!--헤더-->
          <thead>
            <tr>
              <th v-if="multiSelect" style="width: 40px">
                <div class="w-full flex justify-center items-center"><vs-checkbox class="p-0 m-0" :value="isAllSelected" @input="onClickToggleAll" /></div>
              </th>
              <th v-if="baseColumn" style="width: 60px"><span class="w-full text-center">No.</span></th>
              <th
                v-for="head in heads"
                :key="`table_header_${head.name}`"
                class="page-head"
                :class="head.class"
                :style="{ width: `${(approval ? 90 : 96) / heads.length}%`, ...head.style }"
                style="text-align: center"
                :sort-key="head.keyName"
              >
                <span class="w-full" v-html="head.name"></span>
                <div v-if="head.child" class="flex items-center justify-center head-child">
                  <div v-for="_hc in head.child" :style="_hc.style ? _hc.style : `flex:1`" class="h-child">
                    <span v-html="_hc.name"></span>
                  </div>
                </div>
              </th>
              <th v-if="baseColumn && useFinishLater" style="min-width: 100px"><span class="w-full text-center">문서상태</span></th>
              <th v-if="baseColumn && boardSlug && approval" style="min-width: 100px; width: 100px; text-align: center"><span class="w-full text-center">결재상태</span></th>
              <th v-if="baseColumn && moveProject" style="min-width: 200px; width: 200px"><span class="w-full text-center">보기</span></th>
            </tr>
          </thead>

          <!-- 게시글 목록을 불러오는 중일 때 -->
          <tbody v-if="loading">
            <tr>
              <td colspan="100">
                <div class="w-full p-5 flex items-center justify-center" style="min-height: 100px">
                  <feather-icon icon="LoaderIcon" class="mr-2 rotate-icon" />
                  데이터를 불러오는 중입니다.
                </div>
              </td>
            </tr>
          </tbody>

          <!-- 게시글 목록이 없을 때 -->
          <tbody v-else-if="!parsedListForTable || parsedListForTable.length < 1">
            <tr>
              <td colspan="100">
                <div class="w-full p-5 flex items-center justify-center" style="min-height: 100px">
                  <feather-icon icon="AlertTriangleIcon" class="mr-2" />
                  표시할 데이터가 없습니다.
                </div>
              </td>
            </tr>
          </tbody>

          <!-- 게시글 목록이 있을 때 -->
          <tbody v-else>
            <tr
              v-for="(tr, ri) in parsedListForTable"
              :key="ri"
              :style="{ ...(fontSize ? { fontSize } : {}), ...(tr.style || {}) }"
              :class="selectList && tr.raw && selectList.findIndex((item) => item.id === tr.raw.id) >= 0 ? 'selectItem' : ''"
              @click="() => onClickDetail(tr)"
            >
              <td v-if="multiSelect" class="text-center" @click.stop>
                <div class="w-full flex justify-center items-center"><vs-checkbox :value="isRowSelected(tr)" @input="() => onClickToggleRow(tr)" /></div>
              </td>
              <td v-if="baseColumn" class="text-center">
                {{ tr["No"] }}
              </td>

              <td v-for="(head, ci) in heads" :key="`table_list_${ri}_${ci}_${head.name}`" class="text-center" :style="{ width: `${(approval ? 90 : 96) / heads.length}%`, ...head.style }">
                <div v-if="typeof tr[head.name] === 'object'" class="table-list-obj">
                  <slot name="typeObj" :trData="tr[head.name]" :head="head" :ri="ri" :ci="ci"></slot>
                </div>
                <div v-else style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap" :title="tr[head.name] ? tr[head.name] : '　'">
                  {{ tr[head.name] ? tr[head.name] : "　" }}
                </div>
              </td>

              <td v-if="baseColumn && useFinishLater" class="text-center">{{ tr["문서상태"] }}</td>
              <td v-if="baseColumn && boardSlug && approval" class="text-center">
                {{ tr["결재상태"] }}
              </td>

              <td v-if="baseColumn && moveProject" class="text-center" @click.stop>
                <div class="flex justify-center" @click.stop>
                  <vs-button
                    type="border"
                    icon="open_in_new"
                    class="mr-1"
                    @click.stop="
                      () => {
                        onClickDetail(tr, '_blank');
                      }
                    "
                  ></vs-button>
                  <vs-button
                    type="border"
                    @click.stop="
                      () => {
                        onClickDetail(tr, 'self');
                      }
                    "
                    >{{ $t("button.바로가기") }}
                  </vs-button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!--페이지네이션-->
      <div class="vs-con-table" v-if="selectTab === 0">
        <div class="con-pagination-table vs-table--pagination">
          <k-pagination :total="lastPage" :max-items="5" v-model="currentPage" @change="onChangePage"></k-pagination>
        </div>
      </div>
    </div>
  </vx-card>
</template>

<script>
import KPagination from "@/components/kPagination/kPagination";

export default {
  name: "ThemeOrigin",
  components: {
    KPagination,
  },
  props: {
    perPage: {
      type: Number,
      required: true,
    },
    cardClass: {
      type: String,
      default: "",
    },
    baseColumn: {
      type: Boolean,
      default: true,
    },
    heads: {
      type: Array,
      required: true,
    },
    parsedListForTable: {
      type: Array,
      required: true,
    },
    approval: {
      type: Boolean,
      default: false,
    },
    useFinishLater: {
      type: Boolean,
      default: false,
    },
    boardSlug: {
      type: String,
      default: "",
    },
    moveProject: {
      type: Boolean,
      default: false,
    },
    selectList: {
      type: Array,
      default: () => [],
    },
    fontSize: {
      type: String,
      default: "",
    },
    selectTab: {
      type: Number,
      default: 0,
    },
    lastPage: {
      type: Number,
      required: true,
    },
    page: {
      type: Number,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    minWidth: Number,
    multiSelect: {
      type: Boolean,
      default: false,
    },
    multiSelectList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    currentPage: {
      get() {
        return this.page;
      },
      set(value) {
        this.$emit("update:page", value);
      },
    },
    isAllSelected() {
      return this.parsedListForTable.length > 0 && this.parsedListForTable.every((item) => this.multiSelectList.findIndex((select) => select.postId === item.postId) >= 0);
    },
  },
  methods: {
    onClickSort(sortKey, orderBy) {
      this.$emit("sort", sortKey, orderBy);
    },
    onClickDetail(item, target = "self") {
      this.$emit("selected", item, target);
    },
    onChangePage(page) {
      this.$emit("change", page);
    },
    onChangePerPage(perPage) {
      this.$emit("changePerPage", perPage);
    },
    isRowSelected(tr) {
      return this.multiSelectList.findIndex((select) => select.postId === tr.postId) >= 0;
    },
    onClickToggleAll() {
      this.$emit("allCheck");
    },
    onClickToggleRow(tr) {
      this.$emit("toggleRow", tr);
    },
  },
};
</script>
<style lang="scss" scoped>
.rotate-icon {
  animation: rotate 2s linear infinite;
}
table.theme-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;

  &,
  th,
  td {
    border: 1px solid #cdcdcd;
    padding: 0;
  }

  th {
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    background: #fafafa;

    span {
      display: block;
      padding: 10px 0;
    }

    .head-child {
      & > .h-child {
        border: 1px solid #cdcdcd;
        border-left: 0;
        border-bottom: 0;

        &:last-child {
          border-right: 0;
        }
      }
    }
  }

  td {
    cursor: pointer;
    & > div:not(.table-list-obj) {
      padding: 11px 0;
    }

    .table-list-obj > div:not(.body-child) {
      padding: 11px 4px;
    }

    // 성분별로 row 가 여러 줄 나오는 구성성분 칸은, 칸 내부 격자선이 셀 끝까지 닿도록 padding 을 없앤다.
    .table-list-obj > div.body-child-table {
      padding: 0 !important;
    }

    .body-child {
      & > div {
        border-right: 1px solid #cdcdcd;
        padding: 11px 0;

        &:last-child {
          border-right: 0;
        }
      }
    }
  }
}

.striped-table {
  table {
    border: 0;

    thead {
      th {
        height: 1px;

        .head-child {
          height: calc(100% - 41px);

          .h-child {
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 10px 4px;

            span {
              padding: 0;
            }
          }
        }
      }
    }

    thead tr {
      th {
        background-color: white;
      }

      th span {
        padding: 10px 0;
      }
    }

    tbody tr td,
    tbody td .body-child > div {
      border-left: 0;
      border-right: 0;
    }

    tbody tr:nth-child(2n - 1) {
      td {
        background-color: rgba(0, 0, 0, 0.04);
      }
    }
  }
}

// 804 List(listTheme: "table")와 동일한 기본 헤더/셀 레이아웃을 그대로 쓰고,
// 배경색만 다르게 준다. (striped-table 의 height:1px 트릭은 여러 줄(<br/>) 헤더가 있는
// 897 전용 보정이라 여기서는 필요 없다 — 그대로 쓰면 오히려 레이아웃이 깨져 보인다.)
.striped-table-bordered {
  table {
    thead tr th {
      background-color: #f9f9f9;
    }

    tbody td {
      background-color: white;
    }
  }
}
</style>
